import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiUrl: process.env.NODE_ENV === 'production' ? 'https://hubspotpdf.manobyte.com' : 'http://localhost:5000',
    routeLoaded: false,
    showErrorMsg: false,
    errorMsg: 'There was an error.',
    portalId: '',
    customTemplates: [],
    tier: 1,
    isSystemAdmin: false,
    sessionChecked: false,
    userId: null,
    accountRole: null as string | null,
    linkedAccounts: [] as any[],
    needsReconnect: false
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
